<style src="vue-pdf/src/annotationLayer.css"></style>
<script>

import componentFactory from 'vue-pdf/src/componentFactory.js'

if (process.env.VUE_ENV !== 'server') {
    const pdfjsWrapper = require('vue-pdf/src/pdfjsWrapper.js').default
    const PDFJS = require('pdfjs-dist/es5/build/pdf.js')

    if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {
        let workerReady = false
        try {
            const PdfjsWorkerModule = require('worker-loader!pdfjs-dist/es5/build/pdf.worker.js')
            const PdfjsWorkerCtor = PdfjsWorkerModule.default || PdfjsWorkerModule
            if (typeof PdfjsWorkerCtor === 'function') {
                PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorkerCtor()
                workerReady = true
            } else if (typeof PdfjsWorkerCtor === 'string') {
                PDFJS.GlobalWorkerOptions.workerSrc = PdfjsWorkerCtor
                workerReady = true
            }
        } catch (error) {
            workerReady = false
        }
        if (!workerReady) {
            PDFJS.disableWorker = true
        }
    }

    var component = componentFactory(pdfjsWrapper(PDFJS))
} else {
    var component = componentFactory({})
}

export default component
</script>
